import * as yup from "yup";
import { Card, styled } from "@mui/material";
import axiosInstant from "../../../api";
import { getCheckoutSession } from "../../../api/endpoints";

export const BANNED_EMAIL_DOMAINS = [
  // Gmail and Google variants
  'gmail.com',
  'googlemail.com',
  // Yahoo variants
  'yahoo.com',
  'yahoo.co.uk',
  'yahoo.fr',
  'yahoo.de',
  'yahoo.co.jp',
  'yahoo.ca',
  'yahoo.com.au',
  'yahoo.in',
  'yahoo.it',
  'yahoo.es',
  'yahoo.com.br',
  'yahoo.com.mx',
  'yahoo.com.ar',
  'yahoo.com.sg',
  'yahoo.co.id',
  'yahoo.com.ph',
  'yahoo.com.tw',
  'yahoo.com.hk',
  'yahoo.co.kr',
  'yahoo.co.nz',
  'yahoo.co.za',
  'yahoo.com.tr',
  'yahoo.com.vn',
  'ymail.com',
  'rocketmail.com',
  // Hotmail variants
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.fr',
  'hotmail.de',
  'hotmail.it',
  'hotmail.es',
  'hotmail.com.br',
  'hotmail.com.mx',
  'hotmail.com.au',
  'hotmail.ca',
  'hotmail.co.jp',
  'hotmail.co.in',
  'hotmail.co.za',
  'hotmail.com.tr',
  // Outlook variants
  'outlook.com',
  'outlook.com.au',
  'outlook.fr',
  'outlook.de',
  'outlook.it',
  'outlook.es',
  'outlook.com.br',
  'outlook.com.mx',
  'outlook.co.uk',
  'outlook.co.jp',
  'outlook.co.in',
  'outlook.co.za',
  'outlook.com.tr',
  'live.com',
  'live.co.uk',
  'live.fr',
  'live.de',
  'live.it',
  'live.com.au',
  'live.ca',
  'msn.com',
  // Apple/Mac variants
  'icloud.com',
  'me.com',
  'mac.com',
  // AOL variants
  'aol.com',
  'aol.co.uk',
  'aol.fr',
  'aol.de',
  'aol.it',
  'aol.com.au',
  'aol.ca',
  'aim.com',
  'netscape.net',
  // Mail.com variants
  'mail.com',
  'email.com',
  'inbox.com',
  'usa.com',
  'myself.com',
  'consultant.com',
  'post.com',
  'europe.com',
  'asia.com',
  'writeme.com',
  // GMX variants
  'gmx.com',
  'gmx.net',
  'gmx.de',
  'gmx.at',
  'gmx.ch',
  'gmx.fr',
  'gmx.co.uk',
  'gmx.es',
  'gmx.it',
  // Zoho
  'zoho.com',
  'zoho.eu',
  'zoho.com.au',
  'zoho.in',
  // ProtonMail variants
  'protonmail.com',
  'protonmail.ch',
  'proton.me',
  // Yandex variants
  'yandex.com',
  'yandex.ru',
  'yandex.ua',
  'yandex.by',
  'yandex.kz',
  'ya.ru',
  // Mail.ru variants
  'mail.ru',
  'bk.ru',
  'list.ru',
  'inbox.ru',
  'rambler.ru',
  // Chinese email providers
  'qq.com',
  '163.com',
  '126.com',
  'sina.com',
  'sohu.com',
  'sina.cn',
  'vip.sina.com',
  'foxmail.com',
  '139.com',
  'tom.com',
  '21cn.com',
  // Korean email providers
  'naver.com',
  'daum.net',
  'hanmail.net',
  'kakao.com',
  // Ukrainian email providers
  'ukr.net',
  'i.ua',
  'meta.ua',
  'bigmir.net',
  // Italian email providers
  'libero.it',
  'virgilio.it',
  'tiscali.it',
  'alice.it',
  'tin.it',
  // French email providers
  'orange.fr',
  'laposte.net',
  'wanadoo.fr',
  'sfr.fr',
  'free.fr',
  'club-internet.fr',
  'noos.fr',
  // German email providers
  'web.de',
  't-online.de',
  'freenet.de',
  'gmx.de',
  '1und1.de',
  'arcor.de',
  // Australian email providers
  'bigpond.com',
  'bigpond.net.au',
  'optusnet.com.au',
  'telstra.com',
  'westnet.com.au',
  // US ISP email providers
  'cox.net',
  'sbcglobal.net',
  'att.net',
  'bellsouth.net',
  'comcast.net',
  'verizon.net',
  'earthlink.net',
  'charter.net',
  'roadrunner.com',
  'rr.com',
  'adelphia.net',
  'juno.com',
  'netzero.com',
  // Other common providers
  'excite.com',
  'lycos.com',
  'rediffmail.com',
  'rediffmailpro.com',
  'fastmail.com',
  'fastmail.fm',
  'runbox.com',
  'hushmail.com',
  'safe-mail.net',
  'mailfence.com',
  'startmail.com',
  'mailbox.org',
  'posteo.de',
  'tutanota.com',
  'tutanota.de',
  'disroot.org',
  'riseup.net',
  // Disposable/temporary email services
  'mailinator.com',
  '10minutemail.com',
  'guerrillamail.com',
  'tempmail.com',
  'temp-mail.org',
  'throwaway.email',
  'fakemail.net',
  'maildrop.cc',
  '33mail.com',
  'sharklasers.com',
  'grr.la',
  'guerrillamailblock.com',
  'pokemail.net',
  'spam4.me',
  'bccto.me',
  'chacuo.net',
  'dispostable.com',
  'yopmail.com',
  'getnada.com',
  'mohmal.com',
  'mytrashmail.com',
  'trashmail.com',
  'throwawaymail.com',
  'emailondeck.com',
  'fakeinbox.com',
  'meltmail.com',
  'mintemail.com',
  'moburl.com',
  'mytemp.email',
  'nowmymail.com',
  'sharklasers.com',
  'spamgourmet.com',
  'tempail.com',
  'tempinbox.com',
  'tempmailo.com',
  'tmail.ws',
  'tmpmail.org',
  'trbvm.com',
  'trillianpro.com',
  'tyldd.com',
  'vomoto.com',
  'vubby.com',
  'wuzup.net',
  'yapped.net',
  'zoemail.org',
];

export const LoginFormInitialValues = {
  email: "",
  password: "",
  form: null,
};

export const loginSchema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required(),
});

export const ForgetPassFormInitialValues = {
  emailAddress: "",
  form: null,
};

export const forgetPassSchema = yup.object().shape({
  emailAddress: yup.string().email().required(),
});

export const resetPasswordSchema = yup.object().shape({
  password: yup.string().required(),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

export const ResetPasswordInitialValues = {
  password: "",
  passwordConfirmation: "",
  form: null,
};

export const proRegistrationSchema = yup.object().shape({
  email: yup
    .string()
    .email()
    .required()
    .test(
      'banned-domain',
      'Please use a business email, not a public domain like @gmail.com.',
      function (value) {
        if (!value) return true; // Let required validation handle empty values
        const emailDomain = value.split('@')[1]?.toLowerCase();
        return !BANNED_EMAIL_DOMAINS.includes(emailDomain);
      }
    ),
  password: yup.string().required(),
  passwordConfirmation: yup
    .string()
    .required()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  termsCheckbox: yup
    .bool()
    .oneOf([true], "You must agree to the terms stated to complete your registration"),
});

export const ProRegisterInitialValues = {
  ...LoginFormInitialValues,
  passwordConfirmation: "",
  firstName: "",
  lastName: "",
  termsCheckbox: false,
};

export const RegisterInitialValues = {
  ...ProRegisterInitialValues,
  brand: "",
};

export const localCheckoutData = async (checkoutSessionId: string) => {
  try {
    const stripeResponse: any = await axiosInstant.get(
      getCheckoutSession(checkoutSessionId)
    );
    const nameArray = stripeResponse.data.customer_details.name.split(" ");
    return {
      email: stripeResponse.data.customer_details.email,
      firstName: nameArray[0],
      lastName: nameArray[1],
    };
  } catch (err) {
    console.log((err as Error)?.message);
    return {};
  }
};

export const AuthCard = styled(Card)<{ $isWide?: boolean }>`
  max-width: ${({ $isWide }) => ($isWide ? 680 : 450)}px;
  padding: 40px;
  border-radius: 18px;
  width: 100%;
  overflow: auto;
`;
